module.exports = __webpack_public_path__ + "static/media/call_ali.48a3da03.png";